// Minimal React error boundary — swallows child render errors and shows
// a user-friendly fallback instead of a blank white page.
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Console-only — we do not have a client-side logging endpoint. Gated to
    // dev to keep production consoles clean; users can't act on the trace.
    if (process.env.NODE_ENV !== "production") {
      console.error("ErrorBoundary caught:", error, info?.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-screen bg-cream flex items-center justify-center px-6 text-center" data-testid="error-boundary-fallback">
          <p className="text-leaf-mist text-sm">Something went wrong. Try refreshing the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
